import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  DataEntryExampleComponent,
  LoginComponent,
  UsersComponent,
  SearchTestsComponent,
  SearchGridFormatExampleComponent,
  SearchGridLinkDestinationExampleComponent,
  ExceptionExampleComponent,
  ErrorLogComponent,
  ErrorLogsComponent,
  ExamplesComponent,
  ExampleComponent,
  NotificationExampleComponent,
  ExampleFormlyComponent,
  CreateAccountComponent,
  ApplicationSettingComponent,
  ApplicationSettingsComponent,
  CheckpointComponent,
  CheckpointsComponent,
  RolesComponent,
  RoleComponent,
  UserComponent,
  DashboardComponent,
  UserWidgetSelectionComponent,
  AdminTypeLinksComponent,
  CountriesComponent,
  CountryComponent,
  SpkControlsExampleComponent,
  QueuesComponent,
  LandingPageComponent,
  ProjectSummaryComponent,
  NewProjectComponent,
  FeatureReleasesComponent,
  FeatureReleaseDetailComponent
} from './components';

import { CanDeactivateGuard, EditProjectAccessGuard, AuthGuard } from './services';
import { ProjectReadniessFormComponent } from './components/project-readniess-form/project-readniess-form.component';
import { ReadinessAdminFormComponent } from './components/readiness-admin-form/readiness-admin-form.component';
import { ReadinessFormColumnSettingsComponent } from './components/readiness-form-column-settings/readiness-form-column-settings.component';
import { ReadinessGuideComponent } from './components/readiness-guide/readiness-guide.component';
import { SupportTicketComponent } from './components/support-ticket/support-ticket.component';
import { UserSessionsComponent } from './components/user-sessions/user-sessions.component';



const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'create-account', component: CreateAccountComponent },
  { path: 'dashboard', component: LandingPageComponent, canActivate: [AuthGuard] },
  { path: 'user-widget-selection', component: UserWidgetSelectionComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'data', component: DataEntryExampleComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
  { path: 'user/:id', component: UserComponent, canActivate: [AuthGuard] },
  { path: 'search-grid-format', component: SearchGridFormatExampleComponent, canActivate: [AuthGuard] },
  { path: 'search-grid-link/:id', component: SearchGridLinkDestinationExampleComponent, canActivate: [AuthGuard] },
  { path: 'search-tests', component: SearchTestsComponent, canActivate: [AuthGuard] },
  { path: 'error-log/:id', component: ErrorLogComponent, canActivate: [AuthGuard] },
  { path: 'error-logs', component: ErrorLogsComponent, canActivate: [AuthGuard] },
  { path: 'feature-releases', component: LandingPageComponent, canActivate: [AuthGuard] },
  { path: 'feature-releases/:id', component: LandingPageComponent, canActivate: [AuthGuard] },
  { path: 'application-setting/:name', component: ApplicationSettingComponent, canActivate: [AuthGuard] },
  { path: 'application-settings', component: ApplicationSettingsComponent, canActivate: [AuthGuard] },
  { path: 'examples', component: ExamplesComponent, canActivate: [AuthGuard] },
  { path: 'example/:id', component: ExampleComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'example-formly/:id', component: ExampleFormlyComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'exception-example', component: ExceptionExampleComponent, canActivate: [AuthGuard] },
  { path: 'notification-example', component: NotificationExampleComponent, canActivate: [AuthGuard] },
  { path: 'checkpoints', component: CheckpointsComponent, canActivate: [AuthGuard] },
  { path: 'checkpoint/:id', component: CheckpointComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'roles', component: RolesComponent, canActivate: [AuthGuard] },
  { path: 'countries', component: CountriesComponent, canActivate: [AuthGuard] },
  { path: 'country/:id', component: CountryComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'admin-type-links', component: AdminTypeLinksComponent, canActivate: [AuthGuard] },
  { path: 'role/:id', component: RoleComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'spk-controls-examples', component: SpkControlsExampleComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'queues', component: QueuesComponent, canActivate: [AuthGuard] },
  { path: 'projects', component: LandingPageComponent, canActivate: [AuthGuard] },
  { path: 'project/:id', component: ProjectSummaryComponent, canActivate: [AuthGuard] },
  { path: 'new-project', component: NewProjectComponent, canActivate: [AuthGuard] },
  { path: 'edit-project/:id', component: NewProjectComponent, canActivate: [AuthGuard, EditProjectAccessGuard] },
  { path: 'readiness-import/:id', component: ProjectReadniessFormComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard]},
  { path: 'readiness-admin-form/:id', component: ReadinessAdminFormComponent, canActivate: [AuthGuard] },
  { path: 'readiness-form-column-settings/:id', component: ReadinessFormColumnSettingsComponent, canActivate: [AuthGuard] },
  { path: 'readiness-guide', component: ReadinessGuideComponent, canActivate: [AuthGuard] },
  { path: 'support-tickets', component: SupportTicketComponent, canActivate: [AuthGuard] },
  { path: 'user-sessions', component: UserSessionsComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: 'login' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
